module.exports = __webpack_public_path__ + "static/media/miterQuestion.4cc7737f.png";